export default (user = {name: null}) => {
  return user;
};
